import React from 'react';

const ServicesSection = () => {
  return (
    <>
      <style jsx>{`
        .services-section-10 {
          background: white;
          padding: 80px 40px;
          position: relative;
          overflow: hidden;
        }

        .services-container-10 {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .services-grid-10 {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: start;
        }

        .service-item-10 {
          text-align: center;
          animation: fadeInUp 0.8s ease-out;
        }

        .service-item-10:nth-child(2) {
          animation-delay: 0.2s;
        }

        .icon-container {
          width: 250px;
          height: 250px;
          margin: 0 auto 30px;
          position: relative;
          cursor: pointer;
          transition: all 0.5s ease;
        }

        .icon-container:hover {
          transform: scale(1.1);
        }

        .circular-border {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
         
        }

        .circular-border::before {
          content: '';
          position: absolute;
          top: -5px;
          left: -5px;
          right: -5px;
          bottom: -5px;
          border-radius: 50%;
          z-index: -1;
          animation: rotateBorder 4s linear infinite;
        }

        @keyframes rotateBorder {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .icon-inner {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
           box-shadow: 0 0px 0px rgba(79, 195, 247, 0.3);
          animation: pulseGlow 3s ease-in-out infinite;
        }

        .icon-inner::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
          animation: shine 3s ease-in-out infinite;
        }

        @keyframes shine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .businessman-icon {
          width: 100%;
          height: 100%;
          background: url('/images/professionels.png') center/cover no-repeat;
          border-radius: 50%;
          position: relative;
          z-index: 2;
        }

        .car-icon {
          width: 100%;
          height: 100%;
          background: url('/images/particulier.png') center/cover no-repeat;
          border-radius: 50%;
          position: relative;
          z-index: 2;
        }

        .service-title {
          font-size: 2.2rem;
          font-weight: bold;
          color: #666;
          margin: 0 0 20px 0;
          font-family: 'Arial', sans-serif;
          line-height: 1.2;
        }

        .service-description-10 {
          font-size: 1.3rem;
          color: #666;
          line-height: 1.6;
          margin: 0 0 40px 0;
          font-family: 'Arial', sans-serif;
          max-width: 500px;
          margin-left: auto;
          margin-right: auto;
        }

        .service-button {
          background: white;
          border: 3px solid #2196F3;
          border-radius: 15px;
          padding: 15px 40px;
          display: flex;
          align-items: center;
          gap: 15px;
          font-size: 1.4rem;
          font-weight: bold;
          color: #2196F3;
          cursor: pointer;
          transition: all 0.3s ease;
          max-width: fit-content;
          margin: 0 auto;
          text-decoration: none;
        }

        .service-button:hover {
          background: #2196F3;
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(33, 150, 243, 0.4);
        }

        .button-icon {
          width: 40px;
          height: 30px;
          background: #2196F3;
          border-radius: 5px;
          position: relative;
          transition: all 0.3s ease;
        }

        .service-button:hover .button-icon {
          background: white;
        }

        .handshake-icon {
          background: linear-gradient(45deg, #f4c2a1 50%, #8d6e63 50%);
          border-radius: 50% 10px 50% 10px;
        }

        .mobile-van-icon {
          background: #2196F3;
          border-radius: 8px 8px 4px 4px;
          position: relative;
        }

        .mobile-van-icon::before {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 5px;
          width: 8px;
          height: 8px;
          background: #333;
          border-radius: 50%;
          box-shadow: 22px 0 0 #333;
        }

        .mobile-van-icon::after {
          content: '';
          position: absolute;
          top: 5px;
          left: 5px;
          right: 5px;
          height: 8px;
          background: rgba(255,255,255,0.3);
          border-radius: 2px;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(50px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 1024px) {
          .services-grid-10 {
            gap: 60px;
          }

          .icon-container {
            width: 220px;
            height: 220px;
          }

          .service-title {
            font-size: 2rem;
          }

          .service-description-10 {
            font-size: 1.2rem;
          }

          .service-button {
            font-size: 1.3rem;
            padding: 12px 35px;
          }
        }

        @media (max-width: 768px) {
          .services-section-10 {
            padding: 60px 20px;
          }

          .services-grid-10 {
            grid-template-columns: 1fr;
            gap: 50px;
          }

          .icon-container {
            width: 200px;
            height: 200px;
          }

          .businessman-icon,
          .car-icon {
            transform: scale(0.9);
          }

          .service-title {
            font-size: 1.8rem;
          }

          .service-description-10 {
            font-size: 1.1rem;
          }

          .service-button {
            font-size: 1.2rem;
            padding: 10px 30px;
          }
        }

        @media (max-width: 480px) {
          .icon-container {
            width: 180px;
            height: 180px;
          }

          .service-title {
            font-size: 1.6rem;
          }

          .service-description-10 {
            font-size: 1rem;
          }

          .service-button {
            font-size: 1.1rem;
            padding: 8px 25px;
            gap: 10px;
          }

          .button-icon {
            width: 35px;
            height: 25px;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="services-section-10"
        role="region"
        aria-labelledby="services-heading"
        itemScope
        itemType="https://schema.org/Service"
      >
        <div className="services-container-10">
          <h2 id="services-heading" className="sr-only">
            Nos services automobiles
          </h2>
          
          <div className="services-grid-10">
            <article className="service-item-10" itemScope itemType="https://schema.org/Service">
              <div className="icon-container" role="img" aria-label="Services pour professionnels">
                <div className="circular-border">
                  <div className="icon-inner">
                    <div 
                      className="businessman-icon"
                      role="img"
                      aria-label="Gestionnaire de flotte pour entreprises"
                    ></div>
                  </div>
                </div>
              </div>
              
              <h3 className="service-title" itemProp="name">
                Gestionnaire de flotte
              </h3>
              
              <p className="service-description-10" itemProp="description">
                Optimisez l'entretien de votre parc<br />
                auto avec un interlocuteur dédié.
              </p>
              
              <button 
                className="service-button"
                aria-label="Découvrir nos services professionnels pour gestionnaires de flotte"
                itemProp="url"
              >
                <img src='/images/contract.png'  height={64} width={48} alt="Contrat professionnel" loading="lazy" />
                Services professionnels
              </button>
            </article>

            <article className="service-item-10" itemScope itemType="https://schema.org/Service">
              <div className="icon-container" role="img" aria-label="Services pour particuliers">
                <div className="circular-border">
                  <div className="icon-inner">
                    <div 
                      className="car-icon"
                      role="img"
                      aria-label="Services pour propriétaires de voiture"
                    ></div>
                  </div>
                </div>
              </div>
              
              <h3 className="service-title" itemProp="name">
                Propriétaire de voiture
              </h3>
              
              <p className="service-description-10" itemProp="description">
                Réservez votre vidange à<br />
                domicile en quelques clics.
              </p>
              
              <button 
                className="service-button"
                aria-label="Réserver un service d'atelier mobile à domicile"
                itemProp="url"
              >
                <img src='/images/car_small.png' height={64} width={120} alt="Véhicule de service mobile" loading="lazy" />
                Réserver Atelier Mobile
              </button>
            </article>
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ItemList",
              "name": "Services Faucon Bleu",
              "description": "Services automobiles pour particuliers et professionnels",
              "itemListElement": [
                {
                  "@type": "Service",
                  "position": 1,
                  "name": "Gestionnaire de flotte",
                  "description": "Optimisez l'entretien de votre parc auto avec un interlocuteur dédié",
                  "provider": {
                    "@type": "AutoRepair",
                    "name": "Faucon Bleu"
                  },
                  "areaServed": {
                    "@type": "City",
                    "name": "Casablanca"
                  }
                },
                {
                  "@type": "Service",
                  "position": 2,
                  "name": "Atelier Mobile",
                  "description": "Réservez votre vidange à domicile en quelques clics",
                  "provider": {
                    "@type": "AutoRepair",
                    "name": "Faucon Bleu"
                  },
                  "areaServed": {
                    "@type": "City",
                    "name": "Casablanca"
                  }
                }
              ]
            })
          }}
        />
      </section>
    </>
  );
};

export default ServicesSection;